import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: ${Colors.Neutral10};
`
